import React from "react";
import styled from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { fontWeights } from "healthex-common/weights";
import { colors } from "healthex-common/colors";
import Add from "@mui/icons-material/Add";
import { HXButton } from "./HXButton";
export const StudyUserFormParent = styled(FlexColumnDiv) `
    gap: 16px;
    align-self: stretch;
`;
export const AddUsersRow = styled(FlexRowDiv) `
    align-self: stretch;
    align-items: flex-start;
    gap: 10px;

    & > :first-child {
        flex: 1 0 0;
    }
`;
export const CurrentUserTitle = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const AddCurrentUser = styled(FlexColumn) `
    gap: 8px;
`;
export const AddYourselfButton = styled(HXButton).attrs({
    text: true,
    startIcon: React.createElement(Add),
}) `
    min-width: 120px;
`;
export const CurrentUser = styled(FlexRowDiv) `
    justify-content: space-between;
`;
export const CurrentUserNameAndAvatar = styled(FlexRowDiv) `
    gap: 16px;
    align-items: center;
`;
export const UserName = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const CurrentUserOrgName = styled.div `
    color: ${colors.black_lighter};
    text-align: right;
`;
export const RemoveMenuItem = styled.div `
    color: ${colors.tulip_main};
`;
